import { Timestamp } from "@super-real/types";
import { DateTime } from "luxon";

export const toLocaleDateTimeString = (timestamp: Timestamp) => {
  return DateTime.fromJSDate(timestamp.toDate()).toFormat(
    "dd/M/yyyy 'at' HH:mm"
  );
};
